<template>
  <div class="warpper">
    <div class="top" v-if="!edit">
      <div class="btn">
        <el-button type="primary" @click="allList()">全部</el-button>
      </div>
      <div class="_op">
        <el-select v-model="letter" :placeholder="letter_text" @visible-change="Vchange">
          <el-option v-for="(item,index) in letters" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </div>
      <div class="_op">
        <el-select v-model="type" placeholder="药品类别">
          <el-option
            v-for="(item,index) in types"
            :key="index"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="keyword">
        <el-input v-model="keyword" placeholder="请输入搜索内容" @keyup.enter.native="search()"></el-input>
      </div>
      <div class="btn">
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>
    </div>
    <div class="top" v-else>药品编辑</div>
    <div class="content" v-if="durgList.length>0">
      <div class="left" v-if="!edit">
        <div class="drug-item" v-for="(item,index) in durgList" :key="index">
          <div class="_item-title">
            <el-radio v-model="durgItem" :label="index" @change="durgChange">{{item.title}}</el-radio>
          </div>
        </div>
        <div class="left_foo">
          <el-pagination
            small
            @current-change="currentPageChange"
            :page-size="page.pageSize"
            :current-page="page.pageNum"
            :total="page.total"
            layout="total, prev, pager, next"
          ></el-pagination>
        </div>
      </div>
      <div class="right" v-if="rightShow">
        <el-form ref="caseForm" label-width="120px" :rules="caseFormRules" :model="caseForm">
          <el-form-item style="margin-bottom: 0px;" v-model="caseForm.title" label="所选药品">
            <p>{{curCase.title}}</p>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px;" v-model="caseForm.specs" label="药品规格">
            <p>{{curCase.specs}}</p>
          </el-form-item>
          <el-form-item label="数量" prop="quantity" style="margin-bottom: 20px;">
            <el-input-number size="mini" :min="0" v-model="caseForm.quantity"></el-input-number>
          </el-form-item>
          <el-form-item label="单次用量" prop="dosage" style="margin-bottom: 10px;">
            <el-input
              v-model="caseForm.dosage"
              :min="0"
              type="number"
              style="width:45%"
              placeholder="药量"
            ></el-input>
            <el-form-item style="width:45%;float: right; margin-bottom: 10px;" prop="unit">
              <el-select style="width:100%" v-model="caseForm.unit" filterable placeholder="单位">
                <el-option
                  v-for="item in drugs_system_list.drug_unit"
                  :key="item.value"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>

          <el-form-item label="给药频率" prop="frequency" style="margin-bottom: 20px;">
            <el-select
              style="width:100%"
              v-model="caseForm.frequency"
              value-key="id"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in drugs_system_list.drug_frequency"
                :key="item.value"
                :label="item.name"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="给药途径" prop="from" style="margin-bottom: 20px;">
            <el-select style="width:100%" v-model="caseForm.from" filterable placeholder="请选择">
              <el-option
                v-for="item in drugs_system_list.drug_channel"
                :key="item.value"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用药天数" prop="time" style="margin-bottom: 20px;">
            <el-select style="width:100%" v-model="caseForm.time" filterable placeholder="请选择">
              <el-option
                v-for="item in drugs_system_list.doctor_revisit_time"
                :key="item.value"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="补充说明(选填)" prop="remark" style="margin-bottom: 20px;">
            <el-input v-model="caseForm.remark" style="width:100%" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 10px;">
            <div class="foo">
              <el-button type="primary" style="width:100%" @click="addDrug()">确定</el-button>
              <el-button type="primary" style="width:100%" v-if="edit" @click="deleteDrup()">删除</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="emtyData-center" v-else>
      <emptyData></emptyData>
    </div>
  </div>
</template>
<script type="text/javascript">
/**
 * @name 药品筛选弹窗
 * @desc 数据列表
 */
import util from "@/utils";
import { drugSearch, getSystem } from "@/api";
import emptyData from "@/components/common/emptyData";
export default {
  components: {
    emptyData
  },
  props: {
    drugs: Array
  },
  data() {
    return {
      letter: "",
      letter_text: "请选择字母顺序",
      keyword: "",
      types: [{ title: "西药", id: 1 }, { title: "中成药", id: 2 }],
      type: 1,
      letters: [
        "",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "W",
        "X",
        "Y",
        "Z"
      ],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: ""
      },
      durgList: [],
      caseForm: {
        drugs_id: "",
        quantity: "",
        dosage: "",
        unit: "",
        frequency: "",
        from: "",
        time: "",
        remark: ""
      },
      drugs_system_list: [],
      durgItem: "",
      curCase: "",
      edit: false,
      rightShow: false,
      caseFormRules: {
        title: [{ required: true, message: "无此名称药品", trigger: "blur" }],
        specs: [{ required: true, message: "请选择药品规格", trigger: "blur" }],
        quantity: [
          { required: true, message: "请选择药品数量", trigger: "blur" }
        ],
        dosage: [
          { required: true, message: "请选择药品单次用量", trigger: "blur" }
        ],
        unit: [{ required: true, message: "请选择单位", trigger: "change" }],
        frequency: [
          { required: true, message: "请选择频率", trigger: "change" }
        ],
        from: [
          { required: true, message: "请选择药品途径", trigger: "change" }
        ],
        time: [{ required: true, message: "请选择用药天数", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.system_list();
  },
  methods: {
    /**
     * 改变字母排序提示问题
     */
    Vchange(type) {
      if (type && this.letter == "") {
        this.letter_text = "所选字母为空";
      } else {
        this.letter_text = "请选择字母顺序";
      }
    },
    //编辑回填数据
    initDetail(item) {
      this.edit = true;
      this.curCase = item;
      this.caseForm = item;
      this.rightShow = true;
    },
    /**
     * 全部
     */
    allList() {
      this.type = 1;
      this.keyword = "";
      this.letter = "";
      this.page.pageNum = 1;
      this.rightShow = false;
      this.init();
    },
    search() {
      this.page.pageNum = 1;
      this.rightShow = false;
      this.init();
    },
    //初始化数据项
    init() {
      let params = {
        type: this.type,
        keyword: this.keyword,
        cate_id: "",
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        pinyin: this.letter
      };
      drugSearch(params).then(res => {
        let result = res.data;
        if (res.code == 1) {
          this.durgList = result.data;
          this.durgItem = "";
          this.page.pageNum = result.pageNum;
          this.page.total = result.total;
        }
      });
    },
    //分页
    currentPageChange(e) {
      this.page.pageNum = e;
      this.rest();
      this.init();
    },
    //药品单位列表
    system_list() {
      let data = {
        type: "all"
      };
      getSystem(data).then(res => {
        this.drugs_system_list = res.data;
      });
    },
    //药品选择事件
    durgChange(e) {
      this.rightShow = true;
      this.curCase = this.durgList[e];
      this.initCaseForm();
    },
    //确定添加药品事件
    addDrug() {
      this.$refs.caseForm.validate(valid => {
        if (valid) {
          this.edit = false;
          let data = {
            durgType: this.type,
            ...this.curCase,
            drugs_name: this.curCase.title,
            drugs_id: this.caseForm.drugs_id,
            quantity: this.caseForm.quantity,
            dosage: this.caseForm.dosage,
            unit: this.caseForm.unit,
            frequency: this.caseForm.frequency.name,
            from: this.caseForm.from,
            remark: this.caseForm.remark,
            time: this.caseForm.time,
            medicine_freq: this.caseForm.frequency.id, //用量编码
            drugs_code: this.curCase.drugs_code, //药品编码
            drug_unit: this.curCase.unit
          };
          this.$emit("on-drug-add", data);
          this.initCaseForm();
        }
      });
    },
    //删除药品
    deleteDrup() {
      this.edit = false;
      this.$emit("on-delete", {
        durgType: this.type,
        ...this.curCase,
        ...this.caseForm
      });
      this.initCaseForm();
    },
    initCaseForm() {
      this.caseForm.drugs_id = "";
      this.caseForm.quantity = "";
      this.caseForm.dosage = "";
      this.caseForm.unit = "";
      this.caseForm.frequency = "";
      this.caseForm.from = "";
      this.caseForm.remark = "";
      this.caseForm.time = "";
    },
    rest() {
      this.edit = false;
      this.rightShow = false;
      this.curCase = "";
      this.durgItem = "";
      this.initCaseForm();
    },
    initRight() {
      this.edit = false;
      this.durgItem = "";
      this.rightShow = false;
      this.type = 1;
      this.keyword = "";
      this.letter = "";
      this.page.pageNum = 1;
      this.initCaseForm();
      this.init();
    }
  }
};
</script>

<style lang="scss" type="text/css">
.warpper {
  min-height: 570px;
  .top {
    display: flex;
    width: 75%;
    color: #999999;
    ._op {
      flex: 0 0 20%;
      display: flex;
      align-items: center;
    }
    .keyword {
      flex: 1;
      display: flex;
      align-items: center;
    }
  }

  .content {
    display: flex;
    margin: 20px 0 0 0;
    .left {
      flex: 0 0 50%;
      border-right: 1px solid #999999;
      margin-right: 5px;
      .drug-item {
        background: #fafafa;
        margin: 10px 20px 0 0;
        ._item-title {
          display: flex;
          align-items: center;
          padding: 10px 20px;
        }
      }
      .left_foo {
        margin-top: 15px;
        text-align: center;
        font-size: 22px;
        // i:nth-child(1) {
        //   margin-right: 20px;
        // }
      }
    }
    .right {
      flex: 0 0 50%;
      .foo {
        display: flex;
      }
    }
  }
  .emtyData-center {
    min-height: 500px;
    margin: 0 auto;
    align-items: center;
  }
}
</style>
